/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Status,
  Status$inboundSchema,
  Status$outboundSchema,
} from "./status.js";

/**
 * Function call output item: The output payload returned from a function tool call.
 */
export type FunctionToolCallOutput = {
  type: "function_call_output";
  callId: string;
  output: string;
  id?: string | undefined;
  /**
   * The processing status of an individual item. 'in_progress' means currently processing, 'completed' means finished successfully, 'incomplete' means processing stopped before completion.
   */
  status?: Status | undefined;
};

/** @internal */
export const FunctionToolCallOutput$inboundSchema: z.ZodType<
  FunctionToolCallOutput,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("function_call_output"),
  call_id: z.string(),
  output: z.string(),
  id: z.string().optional(),
  status: Status$inboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    "call_id": "callId",
  });
});
/** @internal */
export type FunctionToolCallOutput$Outbound = {
  type: "function_call_output";
  call_id: string;
  output: string;
  id?: string | undefined;
  status?: string | undefined;
};

/** @internal */
export const FunctionToolCallOutput$outboundSchema: z.ZodType<
  FunctionToolCallOutput$Outbound,
  z.ZodTypeDef,
  FunctionToolCallOutput
> = z.object({
  type: z.literal("function_call_output"),
  callId: z.string(),
  output: z.string(),
  id: z.string().optional(),
  status: Status$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    callId: "call_id",
  });
});

export function functionToolCallOutputToJSON(
  functionToolCallOutput: FunctionToolCallOutput,
): string {
  return JSON.stringify(
    FunctionToolCallOutput$outboundSchema.parse(functionToolCallOutput),
  );
}
export function functionToolCallOutputFromJSON(
  jsonString: string,
): SafeParseResult<FunctionToolCallOutput, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FunctionToolCallOutput$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FunctionToolCallOutput' from JSON`,
  );
}
